import React, { createContext, useState, ReactNode, useContext } from 'react';

interface ProductoFileContextType {
  imageProducto: File | null;
  setImageProducto: React.Dispatch<React.SetStateAction<File | null>>;
  pdfProducto: File | null;
  setPdfProducto: React.Dispatch<React.SetStateAction<File | null>>;
}

const ProductoFileContext = createContext<ProductoFileContextType | undefined>(
  undefined
);

export const ProductoFileProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [imageProducto, setImageProducto] = useState<File | null>(null);
  const [pdfProducto, setPdfProducto] = useState<File | null>(null);

  return (
    <ProductoFileContext.Provider
      value={{
        imageProducto,
        setImageProducto,
        pdfProducto,
        setPdfProducto,
      }}
    >
      {children}
    </ProductoFileContext.Provider>
  );
};

export const useProductoFileContext = (): ProductoFileContextType => {
  const context = useContext(ProductoFileContext);
  if (context === undefined) {
    throw new Error('useFileContext must be used within a FileProvider');
  }
  return context;
};
